<h2 class="help__heading">For The Record Support</h2>

<p class="help__description">
  If you’re having trouble logging in or experiencing other technical issues in Justice Cloud, please contact
  <a
    class="help__email"
    data-track
    data-track-group="Support"
    href="mailto:support@fortherecord.com?subject=Support request from app.fortherecord.com{{
      isLoggedIn ? ' (User ID: ' + (currentUser$ | async)?.data?.id + ')' : ''
    }}"
  >
    support&#64;fortherecord.com</a
  >
</p>
